import { useMemo } from 'react';

import { useIsLoggedIn } from '@order/AuthMachine';

import { usePaymentMethodCardsQuery } from './graphql/PaymentMethodCards.generated';

export const usePaymentMethodCards = (
  props: UsePaymentMethodCardsDataProps,
) => {
  const { pause } = props;

  const isLoggedIn = useIsLoggedIn();

  const [{ data, fetching }] = usePaymentMethodCardsQuery({
    requestPolicy: 'cache-and-network',
    pause: !isLoggedIn || pause,
  });

  const isLoadingPaymentMethodCards = fetching;
  const paymentMethodCards = useMemo(
    () => data?.paymentMethodCards ?? [],
    [data?.paymentMethodCards],
  );

  return {
    paymentMethodCards,
    isLoadingPaymentMethodCards,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UsePaymentMethodCardsDataProps = Readonly<{
  pause: boolean;
}>;
